import React from 'react';
import './omos.css';
import OmSection from '../../components/om'; // Importerer Om komponenten fra forsiden

const Omos = () => {
  return (
    <div className="omos-side">
      <OmSection />
    </div>
  );
};

export default Omos;
